<app-page [inTutorial]="true">
  <trade-creator-modal [inTutorial]="true" [tutorialBuy]="false"></trade-creator-modal>
</app-page>
